import { Directive, ViewContainerRef } from '@angular/core'

@Directive({
  selector: '[componentInsertion]',
})
export class InsertionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
